import { useSelector } from "react-redux";

import "./loadingCircle.css";
import { RootState } from "../../../store/store";

const LoadingGlobalComp = (props: any) =>
{

  const colorConfig = useSelector(
    (state: RootState) => state.appCommonSlice.colorConfig
  );
  return (
    <div
      className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 h-full w-full flex items-center justify-center"
      style={{
        background: colorConfig?.loading?.background,
        zIndex: 999999,
        opacity: 0.7,
      }}
    >
      <span
        className="loader"
        style={{
          borderColor: colorConfig?.loading?.color,
        }}
      ></span>
    </div>
  );
};

export default LoadingGlobalComp;
